import { ArrowUpRight, FileText, Lock } from "lucide-react";
import { CornerMarks } from "@/components/infra";

export const DeckLibraryCard = ({ deck, onSelect }) => (
  <button
    type="button"
    data-testid={`deck-card-${deck.key}`}
    onClick={() => onSelect(deck)}
    aria-label={`Request access to DCYB ${deck.title} (password-protected)`}
    className="group relative min-w-0 text-left chrome-surface p-5 md:p-6 transition-shadow duration-300 hover:shadow-[0_18px_44px_rgba(15,17,23,0.12)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0F1117]"
  >
    <CornerMarks color="#A9ADB4" />
    <div className="flex flex-wrap items-center justify-between gap-2 mb-5">
      <span data-testid={`deck-audience-${deck.key}`} className="font-mono-label text-[9.5px] !tracking-normal uppercase text-[#5F6168]">{deck.audience}</span>
      <span data-testid={`deck-pages-${deck.key}`} className="font-mono-label text-[9.5px] !tracking-normal uppercase text-[#5F6168] inline-flex items-center gap-1.5">
        <FileText size={11} aria-hidden="true" />PDF · {deck.pages}
      </span>
    </div>
    <h3 data-testid={`deck-title-${deck.key}`} className="font-display text-xl md:text-2xl font-extrabold tracking-normal text-[#0F1117] mb-2">
      {deck.title.replace(" Deck", "")} <span className="text-chrome">Deck.</span>
    </h3>
    <p data-testid={`deck-description-${deck.key}`} className="text-[13px] text-[#5F6168] leading-relaxed mb-6 min-h-10">{deck.sub}</p>
    <span className="inline-flex items-center gap-1.5 font-mono-label text-[10px] !tracking-normal uppercase text-[#0F1117]">
      <Lock size={11} aria-hidden="true" />Request Access
      <ArrowUpRight size={12} aria-hidden="true" className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </span>
  </button>
);